import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import Label from 'src/components/Label';
import DataTable, { DataTableColumn } from 'src/components/table/DataTable';
import api from 'src/services/api';
import { CreatedUpdated } from '../common';
import GoalsToGoalGroupsContextMenu from './GoalsToGoalGroupsContextMenu';

const columns: DataTableColumn[] = [
  {
    header: 'Goal',
    field: 'goal.name',
  },
  {
    header: 'Goal Group',
    field: 'goalGroup.name',
  },
  {
    header: 'Status',
    field: 'status',
    render(value) {
      return (
        <Label color={value === 'active' ? 'success' : 'info'}>
          {value === 'active' ? 'Active' : 'Inactive'}
        </Label>
      );
    },
  },
  {
    header: 'Created',
    field: '$',
    render(value) {
      return <CreatedUpdated by={value.createdBy} date={value.createdOn} />;
    },
  },
  {
    header: 'Updated',
    field: '$',
    render(value) {
      return <CreatedUpdated by={value.updatedBy} date={value.updatedOn} />;
    },
  },
];

export default function GoalToGoalGroupsTable() {
  const { data: mappings = [], refetch } = useQuery(
    ['mappings-goalgroups-to-goals'],
    async () =>
      (await api.carePlan.findMappingsGoalGroupGoal({
        status: '',
      })) as any[]
  );

  useEffect(() => {
    refetch();
  }, []);

  return (
    <div>
      <DataTable
        columns={columns}
        data={mappings}
        selectable
        rowContextMenu={(item: any) => (
          <GoalsToGoalGroupsContextMenu
            item={item}
            onDelete={() => {
              refetch();
            }}
          />
        )}
      />
    </div>
  );
}
